import React,{Component} from "react";
import { connect } from "react-redux";
import { Alert, Modal, ModalHeader,ModalBody } from 'reactstrap';
import Form from "./Form";
import Actions from "../../../Actions";
import Tile from "../Layout/Tile";

class TypeAdd extends Component{
    constructor(props){
        super(props);
        this.alertRef = false;
    }

    componentDidUpdate(){
        const {typeStore: { alert: { add } }} = this.props;
        if(add && this.modalRef ) this.modalRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
    }

    render = () => {
        const { typeStore: { alert: { add } }, typeModal: { add: { modal } } , toggleModal } = this.props;
        const { addType } = this.props;
        return (
            <div>
                <Modal size="lg" isOpen={modal} keyboard={false} toggle={() => toggleModal("types","add")}>
                    <ModalHeader toggle={() => toggleModal("types", "add")}>Add Type</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                {add !== false &&
                                    <Alert color={add.type}>
                                        { add.message }
                                    </Alert>                                         
                                }
                                <Form data='' persist={addType} />
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    typeStore: state.typeStore,
    typeModal: state.modalStore.types,
});

const { types, modals } = Actions;

export default connect(mapStateToProps, { ...types, ...modals })(TypeAdd);


// WEBPACK FOOTER //
// ./src/Components/App/Types/Add.js